import component from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-documents/lni-retaliation-documents.component.vue';
import module from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-documents/lni-retaliation-documents.module.js';

export default {
    component,
    module,
};